module.exports = __webpack_public_path__ + "img/hgych.a78b8282.jpg";